import React, { useState, useContext, useRef } from "react";
import { GlobalContext } from "../../context/provider";
import numberbeautify from "../../utils/numberbeautify";
import money_rounding from "../../utils/money_rounding";
import moment from "moment/moment";
import { useReactToPrint } from "react-to-print";

const Item_ledger_table = ({ledger}) => {
    return (
        <div>
            <div className="bg-white border border-slate-100 rounded-xl shadow-sm overflow-x-auto"> 
                {/* Section Header */}
                <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100">
                    <h2 className="text-base font-semibold text-slate-800">لیستی هاموو کردارەکانی کاڵا</h2>
                </div>

                {/* Table */}
                <table className="w-full">
                <thead>
                    <tr className="bg-slate-50 border-b border-slate-100">
                        <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                            جۆری چالاکی
                        </th>
                        <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                            بەروار
                        </th>
                        <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                            ژمارە
                        </th>
                        <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                            بڕی (کڕدراو)/(فرۆشراو)
                        </th>
                        <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                            نرخ
                        </th>
                        <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                            کۆی نرخ
                        </th>
                        <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                            بڕی قازانج
                        </th>
                    </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-50">
                        {(() => {
                        return ledger?.map((lis, index) => {
                            return (
                            <tr key={index} className="hover:bg-slate-50 transition-colors duration-100">
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    {lis.action_type=='sell'?
                                    "فرۆش" + (lis.sell_invoice_type === "loan" ? " (قەرز)" : " (کاش)")
                                    :
                                        "کڕین" + (lis.company_invoice_type === "loan" ? " (قەرز)" : " (کاش)")}
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    {moment(lis.ledger_date).format("YYYY-MM-DD hh:mm A")}
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    {lis.ledger_id}
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    {lis.item_unit_one} {Math.floor(lis.item_qty/lis.item_unit_one_of_many)}/{money_rounding(Number(lis.item_qty) % lis.item_unit_one_of_many)} {lis.item_unit_many}
                                    {/* {lis.item_qty} */}
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    {numberbeautify(money_rounding(lis.ledd_price))} $
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    {numberbeautify(money_rounding(lis.total_amount))} $
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    {lis.action_type=='sell'?numberbeautify(money_rounding(lis.total_profit))+" $":"-"}
                                </td>
                            </tr>
                            );
                        });
                        })()}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default Item_ledger_table